export default "<p>Ios webview: {{ uiwebview }}</p>\n<p>User agent: {{ userAgent }}</p>\n<div id=\"where-am-i\"></div>"